import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import * as colors from "@mui/material/colors";
import Typography from "@mui/material/Typography";

import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  setTravelMode,
  setStartLocation,
  addEndLocation,
  removeEndLocation,
  updateEndLocation,
  searchDirectionStart,
} from "../../store/direction/reducer";
import { suggestionFetchStart } from "../../store/map/reducer";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { RouteResult } from "./route-result";

export const Direction = ({
  onClose = () => { },
  toggleDrawer = () => { },
  activeInnerTab,
  setActiveInnerTab,
  setPath_datas,
  path_datas
}) => {
  const dispatch = useDispatch();

  const { travelMode, startLocation, endLocation } = useSelector(
    (state) => state.direction
  );
  const { t } = useTranslation();

  const { suggestions, fetchSuggestionLoading: loading } = useSelector(
    (state) => state.map
  );

  const handleFindRoute = () => {
    setPath_datas([]);
    dispatch(searchDirectionStart());
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          width: "465px",
          backgroundColor: colors.common.white,
          gap: 1,
          boxShadow: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            borderRadius: 1,
            gap: 1,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton size="large" onClick={toggleDrawer}>
              <MenuIcon />
            </IconButton>
            <Box width="1px" height="30px" bgcolor={colors.grey[400]} />
          </Box>
          <Box
            width="100%"
            sx={{
              display: "flex",
              flexDirection: "column",
              paddingBottom: "30px",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              <Tabs
                value={activeInnerTab}
                onChange={(_, value) => setActiveInnerTab(value)}
                variant="fullWidth"
                sx={{
                  minHeight: "36px",
                  height: "36px",
                  marginBottom: "15px",
                  marginLeft: "10px",
                  marginTop: "8px",
                }}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: colors.cyan[600],
                  },
                }}
              >
                <Tab
                  value="CAR"
                  sx={{
                    minHeight: "36px",
                    height: "36px",
                    width: "36px",
                    minWidth: "36px",
                    marginRight: "15px",
                  }}
                  icon={
                    <DirectionsBusIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />
                  }
                />

                <Tab
                  value="BIKE"
                  sx={{
                    minHeight: "36px",
                    height: "36px",
                    width: "36px",
                    minWidth: "36px",
                    marginRight: "15px",
                  }}
                  icon={
                    <DirectionsBikeIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />
                  }
                />
                <Tab
                  value="WALK"
                  sx={{
                    minHeight: "36px",
                    height: "36px",
                    width: "36px",
                    minWidth: "36px",
                    marginRight: "15px",
                  }}
                  icon={
                    <DirectionsWalkIcon
                      sx={{ fontSize: "18px", color: colors.cyan[600] }}
                    />
                  }
                />
              </Tabs>
              <IconButton
                size="small"
                sx={{
                  marginRight: "10px",
                  marginTop: "8px",
                }}
                onClick={onClose}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: 2,
              }}
            >
              <Autocomplete
                value={startLocation}
                options={suggestions}
                loading={loading}
                popupIcon={false}
                filterOptions={(option) => option}
                   renderOption={(props, option) => {
              let subtitle = '';
              if (option.type === 'city_name') {
                subtitle = 'City';
              } else if (option.type === 'region') {
                subtitle = 'Region';
              } else {
                const city = option.city_name || '';
                const region = option.region || '';
                if (city && region) {
                  subtitle = ` ${region} Region,${city} City`;
                } 
                else if (city) {
                  subtitle = `${city}, City`;
                } else if (region) {
                  subtitle = `${region} Region`;
                }
              }
              return (
                <li {...props} key={option.id}>
                  <Box>
                    <Typography variant="body1">{option.label}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {subtitle}
                    </Typography>
                  </Box>
                </li>
              );
            }}
                onChange={(_, value) =>

                  dispatch(
                    setStartLocation({
                      location: value,
                    })
                  )
                }
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    dispatch(
                      suggestionFetchStart({
                        name: value,
                      })
                    );
                  }
                }}
                renderInput={(params) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LocationOnOutlinedIcon
                      sx={{
                        color: colors.cyan[500],
                        mr: 1,
                      }}
                    />
                    <TextField
                      variant="standard"
                      sx={{
                        flex: 1,
                      }}
                      inputProps={{
                        style: {
                          fontSize: "14px",
                        },
                      }}
                      size="small"
                          placeholder={t('Enter start location')}
                      {...params}
                    />
                  </Box>
                )}
              />
            </Box>

            {endLocation.map((location, idx) => (
              <Box
                key={location.id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  gap: 2,
                }}
              >
                <Autocomplete
                  value={location.value}
                  options={suggestions}
                  loading={loading}
                  popupIcon={false}
                  filterOptions={(option) => option}
                    renderOption={(props, option) => {
              let subtitle = '';
              if (option.type === 'city_name') {
                subtitle = 'City';
              } else if (option.type === 'region') {
                subtitle = 'Region';
              } else {
                const city = option.city_name || '';
                const region = option.region || '';
                if (city && region) {
                  subtitle = ` ${region} Region,${city} City`;
                } 
                else if (city) {
                  subtitle = `${city}, City`;
                } else if (region) {
                  subtitle = `${region} Region`;
                }
              }
              return (
                <li {...props} key={option.id}>
                  <Box>
                    <Typography variant="body1">{option.label}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {subtitle}
                    </Typography>
                  </Box>
                </li>
              );
            }}
                  onChange={(_, value) =>
                    dispatch(
                      updateEndLocation({
                        id: location.id,
                        location: value,
                      })
                    )
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      dispatch(
                        suggestionFetchStart({
                          name: value,
                        })
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: 1,
                      }}
                    >
                      <LocationOnOutlinedIcon
                        sx={{
                          color: colors.blue[600],
                          mr: 1,
                        }}
                      />
                      <TextField
                        variant="standard"
                        sx={{
                          flex: 1,
                        }}
                        inputProps={{
                          style: {
                            fontSize: "14px",
                          },
                        }}
                        size="small"
                        placeholder={t('Enter end location')}
                        {...params}
                      />
                      {idx !== 0 && (
                        <HighlightOffIcon
                          sx={{
                            color: colors.red[700],
                            ml: 2,
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            dispatch(
                              removeEndLocation({
                                id: location.id,
                              })
                            )
                          }
                        />
                      )}
                    </Box>
                  )}
                />
              </Box>
            ))}

            <Box
              sx={{
                // display: "flex",
                alignItems: "center",
                gap: 1,
                ml: 1,
              }}
            >
              <AddCircleOutlineIcon
                sx={{ fontSize: "18px", color: colors.cyan[600] }}
              />

              <Button onClick={() => dispatch(addEndLocation())}>
                {t('Add Destination')}
              </Button>
            </Box>
            <Button
              variant="outlined"
              color="primary"
              sx={{
                mr: "20px",
                mt: "20px",
              }}
              size="small"
              onClick={handleFindRoute}
            >
              {t('Find Route')}
            </Button>
          </Box>
        </Box>
      </Box>
      <RouteResult activeInnerTab={activeInnerTab} path_datas={path_datas} />
    </Box>
  );
};
